import AOS from "aos";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import data from "../ApiUrl/meta_api.js";

function WorkShop() {
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const HomeMeta = data[0]?.workshop_page;
    if (HomeMeta) {
      setMeta(HomeMeta);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  const para1 = [
    "PLC Programming: Hands-on exercises with Mitsubishi, Siemens, and Allen-Bradley PLCs.",
    "SCADA Development: Creating and managing real-time automation systems.",
    "HMI Interfaces: Designing interactive and user-friendly control systems.",
    "IoT Integration: Exploring how IoT and Industry 4.0 are revolutionizing automation.",
    "Maintenance & Troubleshooting: Practical strategies for keeping systems efficient.",
    "Mastery of essential automation tools and systems.",
    "Practical skills to solve real-world automation challenges.",
    "Certification of participation and learning.",
    "Embedded Systems Design and Development: Explore microcontrollers and embedded systems to develop real-time industrial automation solutions.",
    "VFD Programming and Implementation: Learn to configure, program, and optimize Variable Frequency Drives (VFDs) for industrial motor control and energy efficiency.",
  
  ];

  const para2 = [
    "SEO Techniques: Learning the latest trends and strategies for optimization.",
    "Social Media Marketing: Crafting impactful campaigns across platforms.",
    "Content Strategy: Building a compelling narrative for online audiences.",
    "PPC Advertising: Running efficient and cost-effective ad campaigns.",
    "Data Analytics: Using tools like Google Analytics to drive decisions.",
    "Direct application of strategies to real-time projects.",
    "Certification to enhance your professional profile.",
    "Exposure to modern marketing tools and platforms.",
    "Certification of participation and learning.",
  ];

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "WorkShop"}</title>
        <link rel="canonical" href="https://skimitaracademy.com/workshops" />
      </Helmet>

      {/* Banner Section */}
      <div
        className="backgroundCommenImage mb-4 mb-md-5"
        style={{
          backgroundImage: `url(${require("../../assets/images/Intern/WorkShop/close-up-people-learning-job.webp")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "clamp(200px, 30vw, 350px)",
          width: "100%",
          position: "relative",
        }}
      >
        <div className="backgroundcommenImageBannerText"></div>
      </div>

      {/* Introduction Section */}
      <div className="container mb-4 mb-md-5 px-3 px-md-4">
        <h1
          className="text-danger text-center mb-3 mb-md-4"
          style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}
        >
          Workshops: Hands-On Learning for Real-World Impact
        </h1>
        <p
          className="mb-0"
          style={{
            fontSize: "clamp(14px, 2vw, 16px)",
            lineHeight: "1.6",
            textAlign: "justify",
          }}
        >
          Skimitar Hindusthan Training Institute, our workshops are designed to
          provide participants with practical, hands-on training in Industrial
          Automation and Digital Marketing. With a focus on real-world
          applications, these workshops empower individuals to gain in-depth
          knowledge and build skills that are immediately applicable in their
          careers.
        </p>
      </div>

      {/* Industrial Automation Section */}
      <div
        className="container-fluid py-4 py-md-5"
        style={{ backgroundColor: "#1C2254" }}
      >
        <div className="container">
          <div className="row align-items-start">
            <div className="col-12 col-lg-5 order-2 order-lg-1 mb-4 mb-lg-0 d-flex justify-content-center">
              <img
                className="img-fluid rounded"
                alt="Industrial Automation Workshop"
                src={require("../../assets/images/Intern/WorkShop/industrial-employees-working-together-factory-production-line.webp")}
                style={{
                  // maxHeight: "500px",
                  height: "500px",
                  width: "100%",
                  objectFit: "cover",
                  marginTop:"55px"
                }}
              />
            </div>

            <div className="col-12 col-lg-7 order-1 order-lg-2">
              <h2
                className="text-danger mb-3 mb-md-4"
                style={{ fontSize: "clamp(1.3rem, 3vw, 1.8rem)" }}
              >
                Industrial Automation Workshops
              </h2>

              <p
                className="text-white mb-4"
                style={{
                  fontSize: "clamp(14px, 2vw, 16px)",
                  lineHeight: "1.6",
                  textAlign: "justify",
                }}
              >
                Our Industrial Automation workshops offer a unique opportunity
                to work with the latest tools and technologies used in the
                industry. Participants will engage in:
              </p>

              {para1.map((item, index) => (
                <div key={index} className="d-flex align-items-start mb-3">
                  <div className="flex-shrink-0 me-3 mt-1">
                    <i
                      className="fa-solid fa-circle"
                      style={{
                        color: "#dc3545",
                        fontSize: "8px",
                      }}
                    ></i>
                  </div>
                  <p
                    className="text-white mb-0 flex-grow-1"
                    style={{
                      fontSize: "clamp(13px, 1.8vw, 15px)",
                      lineHeight: "1.5",
                      textAlign: "justify",
                    }}
                  >
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Digital Marketing Intro Section */}
      <div className="container mt-4 mt-md-5 mb-4 mb-md-5 px-3 px-md-4">
        <h2
          className="text-danger text-center mb-3 mb-md-4"
          style={{ fontSize: "clamp(1.3rem, 3vw, 1.8rem)" }}
        >
          Digital Marketing Workshops
        </h2>

        <p
          className="mb-0"
          style={{
            fontSize: "clamp(14px, 2vw, 16px)",
            lineHeight: "1.6",
            textAlign: "justify",
          }}
        >
          Dive into the dynamic world of Digital Marketing with workshops
          tailored for aspiring marketers and professionals. Digital marketing
          workshops are specialized training sessions designed to equip
          individuals and businesses with the skills needed to excel in the
          ever-evolving online marketplace. These workshops cover key areas such
          as search engine optimization (SEO), social media marketing, email
          campaigns, content creation, analytics, and pay-per-click advertising.
          By blending theoretical concepts with hands-on practical exercises,
          participants gain valuable insights into crafting effective digital
          strategies.
        </p>
      </div>

      {/* Digital Marketing Section */}
      <div
        className="container-fluid py-4 py-md-5"
        style={{ backgroundColor: "#1C2254" }}
      >
        <div className="container">
          <div className="row align-items-start">
            <div className="col-12 col-lg-7 mb-4 mb-lg-0">
              <h2
                className="text-danger mb-3 mb-md-4"
                style={{ fontSize: "clamp(1.3rem, 3vw, 1.8rem)" }}
              >
                Key Topics
              </h2>

              {para2.map((item, index) => (
                <div key={index} className="d-flex align-items-start mb-3">
                  <div className="flex-shrink-0 me-3 mt-1">
                    <i
                      className="fa-solid fa-circle"
                      style={{
                        color: "#dc3545",
                        fontSize: "8px",
                      }}
                    ></i>
                  </div>
                  <p
                    className="text-white mb-0 flex-grow-1"
                    style={{
                      fontSize: "clamp(13px, 1.8vw, 15px)",
                      lineHeight: "1.5",
                      textAlign: "justify",
                    }}
                  >
                    {item}
                  </p>
                </div>
              ))}
            </div>

            <div className="col-12 col-lg-5 d-flex justify-content-center align-items-start">
              <img
                className="img-fluid rounded"
                alt="Digital Marketing Workshop"
                src={require("../../assets/images/Intern/WorkShop/pexels-gustavo-fring-6285124.webp")}
                style={{
                  height: "400px",
                  width: "100%",
                  objectFit: "cover",
                  marginTop:"40px"
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Content Section */}
      <div className="container mt-4 mt-md-5 mb-4 mb-md-5 px-3 px-md-4">
        <div className="row">
          <div className="col-12">
            <div
              className="p-3 p-md-4 rounded"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <p
                className="text-dark mb-3"
                style={{
                  fontSize: "clamp(14px, 2vw, 16px)",
                  lineHeight: "1.6",
                  textAlign: "justify",
                }}
              >
                A workshop on digital marketing offers participants an in-depth
                understanding of strategies and tools to enhance online
                visibility, reach target audiences, and drive business growth.
                Participants learn key concepts such as SEO, social media
                marketing, email campaigns, and analytics. Through hands-on
                sessions, they explore creating impactful digital content,
                managing ad campaigns, and interpreting data insights to make
                informed decisions.
              </p>

              <p
                className="text-dark mb-0"
                style={{
                  fontSize: "clamp(14px, 2vw, 16px)",
                  lineHeight: "1.6",
                  textAlign: "justify",
                }}
              >
                An industrial automation workshop provides a practical
                introduction to the latest technologies revolutionizing the
                manufacturing and production sectors. Participants gain insights
                into concepts such as PLC programming, robotics, IoT
                integration, and smart manufacturing. Hands-on sessions allow
                attendees to work with automation tools and understand
                real-world applications, including process optimization, cost
                efficiency, and improved safety.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WorkShop;
